/**
 * Toon alle entries van deze groep en maak het mogelijk om toe te voegen
 *
 *
 * @history
 * 9 augustus 2022
 * Basis implementatie
 *
 */

import React from "react";
import {LogTextForm} from "./forms/LogTextForm";
import {LogTextEntry} from "./entries/LogTextEntry";
import {LogImageForm} from "./forms/LogImageForm";
import {LogImageEntry} from "./entries/LogImageEntry";
import {LogLikeForm} from "./forms/LogLikeForm";
import {LogLikeEntry} from "./entries/LogLikeEntry";
import {Popup} from "../containers/Popup";
import {LogAudioForm} from "./forms/LogAudioForm";
import {LogAudioEntry} from "./entries/LogAudioEntry";



function LogFormFactory(props) {
    const log_kinds = {
        like: LogLikeForm,
        text: LogTextForm,
        image: LogImageForm,
        audio: LogAudioForm



    };
    let SpecificForm;
    if (log_kinds.hasOwnProperty(props.kind)) {
        SpecificForm = log_kinds[props.kind];
    } else {

    }
    return <SpecificForm {...props}  />;
}

function LogEntryFactory(props) {
    const log_kinds = {
        like: LogLikeEntry,
        text: LogTextEntry,
        image: LogImageEntry,
        audio: LogAudioEntry


    };
    let SpecificEntry;
    if (log_kinds.hasOwnProperty(props.kind)) {
        SpecificEntry = log_kinds[props.kind];
    } else {

    }
    return <SpecificEntry {...props}  />;
}


export class GroupLogEntries extends React.Component {
    constructor(props) {
        super(props);

        this.state =
            {
                refresh_done: false,
                logs: [],
                curr_log_entry:{},
                curr_log_action:"",
                edit_visible:false


            };

        this.refreshLog = this.refreshLog.bind(this);
        this.editDoneLog = this.editDoneLog.bind(this);
        this.editLog = this.editLog.bind(this);
        this.deleteLog = this.deleteLog.bind(this);
    }

    componentDidMount() {
       this.refreshLog();
    }

    componentDidUpdate()
    {
        setTimeout(function ()
        {
            document.getElementById("scroll_dummy").scrollIntoView({ behavior: "smooth", block: "end", inline: "end" });
        }
        , 1000);
    }

    refreshLog()
    {
        const formData = new FormData();
        formData.append("access_id1", window.app.logboek.access_id1);
        formData.append("access_id2", window.app.logboek.access_id2);
        formData.append("group_id", this.props.group.id);

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        fetch("/get_group_logs", requestOptions)
            .then(response => response.json())
            .then(logs_json => {
                if (logs_json.status == "ok") {

                    this.setState({"refresh_done": true,"logs":logs_json.data});


                } else {
                    console.log("?");
                }
            });
    }

    editLog(p_index, p_kind)
    {
        if (p_kind != 'text' && p_kind != 'image' && p_kind != 'like' && p_kind != 'audio')
        {
            alert('Moet nog verder uitgewerkt worden');
            return;
        }

        if (p_index >= 0) {
            this.setState(
                {
                    edit_visible: true,
                    curr_log_entry: this.state.logs[p_index],
                    curr_log_action:"edit"
                }
            )
        }
        else
        {
            this.setState(
                {
                    edit_visible: true,
                    curr_log_entry:{"kind":p_kind},
                    curr_log_action:"add"
                }
            )
        }

    }

    editDoneLog(p_refresh, p_logs)
    {
        if (p_refresh)
        {
            this.setState({
                edit_visible: false,
               logs: p_logs
            });


        }
        else
        {
            this.setState({
                edit_visible: false,
            });

        }
    }

    deleteLog(p_index)
    {
        if (window.confirm("Deze gegevens echt verwijderen?"))
        {
            const formData = new FormData();
            formData.append("access_id1", window.app.logboek.access_id1);
            formData.append("access_id2", window.app.logboek.access_id2);
            formData.append("group_id", this.props.group.id);
            formData.append("id", this.state.logs[p_index].id);

            const requestOptions = {
                method: 'POST',
                body: formData
            };

            fetch("/delete_log", requestOptions)
                .then(response => response.json())
                .then(logs_json => {
                    if (logs_json.status == "ok") {
                            let old_logs = this.state.logs;
                            old_logs.splice(p_index,1);
                          //  console.log(this.state.logs);
                         //   console.log(old_logs);

                            this.setState({"logs":old_logs});


                    } else {
                        console.log("?");
                    }
                });
        }
    }


    render() {

        return (
            <Popup  has_close_btn={true} title={"Logboek van " + this.props.group.location.title} callback={() => this.props.callback()}>

                {!this.state.refresh_done &&
                    (
                        <p>Bezig met laden ....</p>

                    )}

                {this.state.refresh_done && !this.state.edit_visible && this.state.logs.map((log, log_index) =>
                    (
                       <LogEntryFactory kind={log.kind} log={log} log_index={log_index} edit_callback={this.editLog} delete_callback={this.deleteLog}/>
                    )
                )}




                {this.state.refresh_done && !this.state.edit_visible &&
                    (
                        <div className="logger_buttons">
                            <p>Toevoegen:<br/><br/>
                            <a href="javascript:void(0)"  onClick={() => this.editLog(-1, "text")} className="logger_button"><img src={"/digibord/assets/svgs/ui/text_white.svg"} className={"ui_icon"}/></a>
                            <a href="javascript:void(0)"  onClick={() => this.editLog(-1, "image")} className="logger_button"><img src={"/digibord/assets/svgs/ui/picture_white.svg"} className={"ui_icon"}/></a>
                                <a href="javascript:void(0)"  onClick={() => this.editLog(-1, "audio")} className="logger_button"><img src={"/digibord/assets/svgs/ui/speaker-filled-audio-tool_white.svg"} className={"ui_icon"}/></a>
                                <a href="javascript:void(0)" onClick={() => this.editLog(-1, "like")} className="logger_button"><img src={"/digibord/assets/svgs/ui/like_white.svg"} className={"ui_icon"}/></a>
                            </p>

                        </div>
                    )}
                <div id="scroll_dummy" style={{"float":"left","width":"100%","height":"20px"}}></div>
                {this.state.edit_visible &&
                    (
                       <LogFormFactory kind={this.state.curr_log_entry.kind} action={this.state.curr_log_action} log={this.state.curr_log_entry} location_id={this.props.group.location_id} group_id={this.props.group.id} edit_done_callback={this.editDoneLog} />)
                }


            </Popup>
        );
    }

}
